// @flow
/* eslint import/prefer-default-export:0 */

import ContextEvent from 'app/common/lib/ContextEvent';
import ContextLogger from 'app/common/lib/ContextLogger';
import getClientTrackingParams from 'app/packages/client-tracking-params';
import store from 'app/common/redux/store/singleton';

type EventType = $Values<PCONST.thrift.EventType>;

export type TrackingData = {
  element?: $Values<PCONST.thrift.ElementType>,
  eventData?: Object,
  component?: $Values<PCONST.thrift.ComponentType>,
  objectId?: string,
  view?: $Values<PCONST.thrift.ViewType>,
  viewParameter?: $Values<PCONST.thrift.ViewParameterType>,
  viewData?: Object,
  durationNs?: number,
  pairId?: string,
  clientTrackingParams?: string,

  // Possible aux data
  advertiser_id?: string,
  sterling_on_steroids_ldap?: string,
  viewed_user?: string,
};

function addAdvertiserPropertiesFromState(state, properties: * = {}) {
  // Advertiser Id (gid)
  if (state.advertiser && state.advertiser.id) {
    properties.advertiser_id = state.advertiser.id;
  }

  // For admin users, their ldap & who they are viewing
  if (state.adminUser && state.viewer && state.viewer.username) {
    properties.sterling_on_steroids_ldap = state.adminUser;
    properties.viewed_user = state.viewer.username;
  }
}

export function track(eventName: EventType, properties: TrackingData = {}) {
  const logger = ContextLogger.getInstance();
  const state = store.instance.getState();

  // Extract *special* properties (that really shouldn't be special at all)
  const {
    element,
    eventData,
    component,
    objectId,
    view,
    viewParameter,
    viewData,
    durationNs,
    pairId,
  } = properties;

  let clientTrackingParams = properties.clientTrackingParams;
  if (!clientTrackingParams && state.pins) {
    const pin = state.pins[objectId];
    const location = state.location;
    if (pin) {
      clientTrackingParams = getClientTrackingParams(pin, location) || `${pin.tracking_params}~0`;
    }
  }

  addAdvertiserPropertiesFromState(state, properties);

  delete properties.element;
  delete properties.eventData;
  delete properties.component;
  delete properties.objectId;
  delete properties.view;
  delete properties.viewParameter;
  delete properties.viewData;
  delete properties.durationNs;
  delete properties.pairId;
  delete properties.clientTrackingParams;

  // Build an event
  const event = ContextEvent.fromEventType(eventName);
  event.setElement(element);
  event.updateEventData(eventData);
  event.setComponent(component);
  if (objectId) {
    event.setObjectIdStr(objectId);
  }
  event.setDurationNs(durationNs);
  event.updateAuxData(properties);
  event.setViewType(view);
  event.setViewParameter(viewParameter);
  event.setViewData(viewData);
  event.setPairId(pairId);
  event.setClientTrackingParams(clientTrackingParams);

  // Send the event
  logger.addEvent(event);
}
